import { type IPrivateContactAgreement } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IPrivateContactAgreementState } from './types';

export const GET_FROM_AGREEMENT = 'getFromAgreement';

const getPrivateContactAgreement = (_state: IPrivateContactAgreementState, ids = [] as number[]): IPrivateContactAgreement[] => {
    return ids
        .map((privateContactAgreementId: number) => {
            return _state.dataObjectList.get(privateContactAgreementId);
        })
        .filter((privateContactAgreement) => {
            return privateContactAgreement;
        });
};

export const getters: GetterTree<IPrivateContactAgreementState, unknown> = {
    [GET_FROM_AGREEMENT]: (_state: IPrivateContactAgreementState) => {
        return (agreementId: number): IPrivateContactAgreement[] | undefined => {
            return getPrivateContactAgreement(_state, _state.byAgreement.get(agreementId) ?? []);
        };
    }
};
